module.exports = __webpack_public_path__ + "media/pricing/Enterprise-87bf67b9.png";